export default {
	name: "Liveagent",
	type: "liveagent",
	logo: "/images/logos/liveagent.png",
	subsections: [
		{
			name: "API Connector",
			type: "api connector",
			icon: "compare_arrows",
			activeRules: [
				{
					target: "integration",
					field: "valid",
					value: true
				}
			],
			items: [
				{
					field: "url",
					label: "API URL",
					type: "text",
					validation: [
						{
							type: "contains",
							value: "https://"
						}
					]
				},
				{
					field: "apiKey",
					label: "API key",
					type: "text",
					validation: [
						{
							type: "length",
							value: 32
						}
					]
				},
				{
					field: "apiKeyV1",
					label: "API key V1",
					type: "text",
					validation: [
						{
							type: "length",
							value: 32
						}
					]
				},
				{
					field: "mailboxes",
					label: "Mailboxes",
					type: "text",
					helpText: "Separate the mailboxes by commas"
				},
				{
					type: "webhook url"
				}
			]
		},
		{
			name: "Rules",
			type: "rules",
			icon: "call_split",
			activeRules: [
				{
					target: "integration",
					field: "rules",
					type: "arrayCheck"
				},
				{
					target: "integration",
					field: "rules",
					type: "length-greater-than",
					value: 0
				}
			]
		},
		{
			name: "Users for reassigning",
			type: "users",
			icon: "account_box",
			activeRules: [
				{
					target: "component",
					field: "clientAgents",
					type: "arrayCheck"
				},
				{
					target: "component",
					field: "clientAgents",
					type: "length-greater-than",
					value: 0
				}
			]
		},
		{
			name: "Ticket signature",
			type: "signature",
			icon: "create",
			activeRules: [
				{
					target: "component",
					field: "signature",
					type: "exists"
				}
			]
		},
		{
			name: "Blacklisted words/expressions",
			type: "blacklist",
			icon: "block",
			activeRules: [
				{
					target: "component",
					field: "blacklist",
					type: "arrayCheck"
				},
				{
					target: "component",
					field: "blacklist",
					type: "length-greater-than",
					value: 0
				}
			]
		}
	],
	refreshableFields: [
		{
			text: "Liveagent users/groups",
			value: "users"
		},
		{
			text: "Tags",
			value: "tags"
		},
		{
			text: "Macros",
			value: "macros"
		},
		{
			text: "Check filters",
			value: "checkfilters"
		}
	],
	submitOptions: ["open", "solved"],
	ticketOptions: {
		merge: false,
		editTo: false,
		editCC: false,
		editBCC: false
	}
};
